<!--<app-listar #ctrl URL="titulacion" titulo="Titulación"></app-listar>-->
<app-sistema-menu></app-sistema-menu>

<div class="columns is-gapless" style="height: 100vh; margin: 0; background-color: #f5f5f0;">
    
    <div class="column is-2 is-hidden-mobile">
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>

    <div class="column is-10" style="display: flex; flex-direction: column; height: 100%;">
        
        <!-- Bloque 1: Top Bar -->
        <div class="card mb-4" style="margin: 1rem 1rem 0 1rem;">
            <div class="card-content has-background-primary has-rounded-corners">
                <div class="level is-mobile">
                    <div class="level-left">
                        <div class="level-item">
                            <div class="is-flex is-align-items-center">
                                <span class="icon has-text-white mr-3">
                                    <i class="fas fa-graduation-cap"></i>
                                </span>
                                <h1 class="title is-4 has-text-white is-marginless">Trámites de Títulos Electrónicos</h1>
                            </div>
                        </div>
                    </div>
                    
                    <div class="level-right">
                        <div class="level-item">
                            <div class="field has-addons">
                                
                                <!--<div class="control">
                                    <input 
                                        class="input" 
                                        type="text" 
                                        placeholder="Buscar..." 
                                        [(ngModel)]="campo_buscar"
                                        (keyup.enter)="buscarTramites()"
                                        #buscarInput>
                                </div>-->
                                <div class="control">
                                    <input 
                                        class="input" 
                                        type="search" 
                                        placeholder="Buscar..." 
                                        [(ngModel)]="campo_buscar"
                                        (keyup.enter)="buscarTramites()"
                                        #buscarInput
                                        autocomplete="off"
                                        name="campo_buscar"
                                        id="campo_buscar">
                                </div>

                                <div class="control">
                                    <button 
                                        class="button is-info" 
                                        (click)="buscarTramites()"
                                        title="Buscar">
                                        <span class="icon">
                                            <i class="fas fa-search"></i>
                                        </span>
                                    </button>
                                </div>
                                

                            </div>
                        </div>
                        
                        <div class="level-item">
                            <button 
                                class="button is-light" 
                                (click)="actualizarListado()"
                                [class.is-loading]="isLoading"
                                title="Actualizar listado">
                                <span class="icon">
                                    <i class="fas fa-refresh"></i>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bloque 2: Contenido/Listado -->
        <div class="card is-rounded is-flex-grow-1" style="margin: 0 1rem; border-radius: 8px; display: flex; flex-direction: column;">
            <div class="card-content is-flex-grow-1" style="padding: 0; display: flex; flex-direction: column;">
                
                <!-- Overlay de carga -->
                <div *ngIf="showLoadingOverlay" class="loading-overlay">
                    <div class="loading-content">
                        <div class="loading-spinner">
                            <i class="fas fa-spinner fa-spin fa-3x"></i>
                        </div>
                        <div class="loading-text">
                            <p>Trabajando, por favor espere...</p>
                        </div>
                    </div>
                </div>

                <!-- Tabla con header fijo y contenido scrollable -->
                <div class="table-container is-flex-grow-1" style="overflow: hidden;">
                    <div style="height: 100%; display: flex; flex-direction: column;">
                        <!-- Header fijo -->
                        <div style="flex-shrink: 0;">
                            <table class="table is-fullwidth is-striped is-hoverable is-narrow" style="margin: 0;">
                                <thead style="background-color: #f8f9fa;">
                                    <tr>
                                        <th class="has-text-left" style="width: 8%; padding: 0.75em 0.5em;">FOLIO</th>
                                        <th class="has-text-left" style="width: 12%; padding: 0.75em 0.5em;">CURP</th>
                                        <th class="has-text-left" style="width: 20%; padding: 0.75em 0.5em;">ALUMNO</th>
                                        <th class="has-text-left" style="width: 26%; padding: 0.75em 0.5em;">CARRERA</th>
                                        <th class="has-text-centered" style="width: 10%; padding: 0.75em 0.5em;">FIRMA</th>
                                        <th class="has-text-centered" style="width: 8%; padding: 0.75em 0.5em;">REGISTRO</th>
                                        <th class="has-text-centered" style="width: 8%; padding: 0.75em 0.5em;">STATUS</th>
                                        <th class="has-text-centered" style="width: 6%; padding: 0.75em 0.5em;">ACCIONES</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>

                        <!-- Contenido scrollable -->
                        <div style="flex-grow: 1; overflow-y: auto; max-height: calc(100vh - 300px);">
                            <table class="table is-fullwidth is-striped is-hoverable is-narrow" style="margin: 0;">
                                <tbody>
                                    <tr *ngFor="let item of tramitesLista">
                                        <!--<td class="has-text-left" style="width: 10%; padding: 0.75em 0.5em;">{{ item.folioControl || 'N/A' }}</td>-->

                                        <td class="has-text-left" style="width: 8%; padding: 0.75em 0.5em;">
                                            <a href="javascript:void(0)" 
                                            class="tag is-black is-light has-text-weight-bold clickable"
                                            (click)="abrirModalDetalles(item)"
                                            title="Ver detalles del trámite">
                                                {{ item.folioControl || 'N/A' }}
                                            </a>
                                        </td>

                                        <td class="has-text-left" style="width: 12%; padding: 0.75em 0.5em;">{{ item.curpProfesionista || 'N/A' }}</td>
                                        <td class="has-text-left" style="width: 20%; padding: 0.75em 0.5em;">
                                            {{ item.nombreProfesionista || '' }} 
                                            {{ item.primerApellidoProfesionista || '' }} 
                                            {{ item.segundoApellidoProfesionista || '' }}
                                        </td>
                                        <td class="has-text-left" style="width: 26%; padding: 0.75em 0.5em;">{{ item.nombreCarrera || 'N/A' }}</td>
                                        
                                        <td class="has-text-centered" style="width: 10%; padding: 0.75em 0.5em;">
                                            <span *ngIf="item.sello" class="icon has-text-success">
                                                <i class="fas fa-check-circle"></i>
                                            </span>
                                            <a *ngIf="!item.sello" 
                                            href="javascript:void(0)" 
                                            class="icon has-text-warning clickable"
                                            (click)="abrirModalFirmar(item)"
                                            title="Firmar título">
                                                <i class="fas fa-clock"></i>
                                            </a><br>
                                            <span class="tag is-light">{{ item.nombreResponsable || 'N/D' }}</span>
                                        </td>

                                        <td class="has-text-centered" style="width: 8%; padding: 0.75em 0.5em;">
                                            <span *ngIf="item.numeroLote; else noRegistrado" class="tag is-success is-light">
                                                Num. Lote : {{ item.numeroLote }}
                                            </span>
                                            <ng-template #noRegistrado>
                                                <a *ngIf="item.sello; else soloTexto" 
                                                href="javascript:void(0)" 
                                                class="tag is-danger is-light clickable"
                                                (click)="abrirModalRegistrar(item)"
                                                title="Registrar título">
                                                    NO REGISTRADO
                                                </a>
                                                <ng-template #soloTexto>
                                                    <span class="tag is-light">NO REGISTRADO</span>
                                                </ng-template>
                                            </ng-template>

                                            <span class="tag is-light" *ngIf="item?.numeroLote">
                                                {{ item.fechaRegistro }}
                                            </span>

                                        </td>

                                        <td class="has-text-centered" style="width: 8%; padding: 0.75em 0.5em;">
                                            <a href="javascript:void(0)" 
                                            class="clickable"
                                            (click)="abrirModalConsultar(item)"
                                            title="Consultar título">
                                                <span *ngIf="item.estatusLote; else noDisponible" 
                                                    class="tag" 
                                                    [class]="getEstatusLoteClass(item.estatusLote)">
                                                    {{ item.estatusLote }}
                                                </span>
                                                <ng-template #noDisponible>
                                                    <span class="tag is-light">N / D</span>
                                                </ng-template>
                                            </a>
                                        </td>

                                        <!--<td class="has-text-centered" style="width: 6%; padding: 0.75em 0.5em;">
                                            <div class="buttons are-small is-justify-content-center">
                                                <button class="button is-info is-outlined" 
                                                        (click)="verXML(item)"
                                                        title="Ver XML">
                                                    <span class="icon">
                                                        <i class="fas fa-code"></i>
                                                    </span>
                                                </button>
                                                <button class="button is-warning is-outlined"
                                                        title="Autenticación">
                                                    <span class="icon">
                                                        <i class="fas fa-award"></i>
                                                    </span>
                                                </button>
                                            </div>
                                        </td>-->
                                        <!--<td class="has-text-centered" style="width: 6%; padding: 0.75em 0.5em;">
                                            <div class="buttons are-small is-justify-content-center">
                                                <button class="button is-info is-outlined" 
                                                        (click)="verXML(item)"
                                                        title="Ver XML">
                                                    <span class="icon">
                                                        <i class="fas fa-code"></i>
                                                    </span>
                                                </button>
                                                <button class="button is-warning is-outlined"
                                                        title="Autenticación">
                                                    <span class="icon">
                                                        <i class="fas fa-award"></i>
                                                    </span>
                                                </button>
                                                <button class="button is-danger is-outlined"
                                                        (click)="abrirModalCancelar(item)"
                                                        [disabled]="item.cancelado === 1"
                                                        title="Cancelar título">
                                                    <span class="icon">
                                                        <i class="fas fa-trash"></i>
                                                    </span>
                                                </button>
                                            </div>
                                        </td>-->

                                        <td class="has-text-centered" style="width: 6%; padding: 0.75em 0.5em;">
                                            <div class="buttons are-small is-justify-content-center">
                                                <button class="button is-info is-outlined" 
                                                        (click)="verXML(item)"
                                                        title="Ver XML">
                                                    <span class="icon">
                                                        <i class="fas fa-code"></i>
                                                    </span>
                                                </button>
                                                <button class="button is-primary is-outlined"
                                                        (click)="generarTitulo(item)"
                                                        
                                                        title="Constancia de Autenticación">
                                                    <span class="icon">
                                                        <i class="fas fa-award"></i>
                                                    </span>
                                                </button>
                                                <button class="button is-danger is-outlined"
                                                        (click)="abrirModalCancelar(item)"
                                                        [disabled]="item.cancelado === 1"
                                                        title="Cancelar título">
                                                    <span class="icon">
                                                        <i class="fas fa-trash"></i>
                                                    </span>
                                                </button>
                                                <button class="button is-success is-outlined"
                                                        (click)="descargarLoteTitulo(item)"
                                                        [disabled]="!item.numeroLote"
                                                        title="Descargar lote de título">
                                                    <span class="icon">
                                                        <i class="fas fa-download"></i>
                                                    </span>
                                                </button>
                                            </div>
                                        </td>




                                    </tr>
                                    <tr *ngIf="tramitesLista.length === 0 && !isLoading">
                                        <td colspan="8" class="has-text-centered py-5" style="padding: 0.75em 0.5em;">
                                            <span class="has-text-grey">
                                                <i class="fas fa-inbox mr-2"></i>
                                                No se encontraron trámites
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <!-- Bloque 3: Footer/Paginación -->
        <div class="card is-rounded mt-4" style="margin: 0 1rem 1rem 1rem; border-radius: 8px;">
            <div class="card-content">
                <nav class="pagination is-centered" role="navigation" aria-label="pagination">
                    <a class="pagination-previous" disabled>Anterior</a>
                    <a class="pagination-next">Siguiente</a>
                    <ul class="pagination-list">
                        <li><a class="pagination-link is-current">1</a></li>
                        <li><span class="pagination-ellipsis">&hellip;</span></li>
                        <li><a class="pagination-link">45</a></li>
                    </ul>
                </nav>
            </div>
        </div>

        <!-- Bloque 4:  -->
        <div class="card is-rounded mt-4" style="margin: 0 1rem 1rem 1rem; border-radius: 8px;">
            
        </div>



    </div>
</div>

<!-- Modales (se mantienen igual) -->





<!-- Modal para Detalles de Título Electrónico -->
<div class="modal" [class.is-active]="showDetallesModal">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 80%; max-width: 900px;">
        <header class="modal-card-head">
            <p class="modal-card-title">Detalles de Título Electrónico</p>
            <button class="delete" aria-label="close" (click)="cerrarModalDetalles()"></button>
        </header>
        <section class="modal-card-body">
            <div class="table-container" style="max-height: 400px; overflow-y: auto;">
                <table class="table is-fullwidth is-striped is-hoverable">
                    <thead style="position: sticky; top: 0; background-color: #f8f9fa; z-index: 1;">
                        <tr>
                            <th class="has-text-left" style="width: 40%;">CAMPO</th>
                            <th class="has-text-left" style="width: 60%;">INFORMACIÓN</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">VERSION</td>
                            <td class="has-text-left">{{ itemADetallar?.version || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">FOLIO CONTROL</td>
                            <td class="has-text-left">{{ itemADetallar?.folioControl || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">CURP RESPONSABLE</td>
                            <td class="has-text-left">{{ itemADetallar?.curpResponsable || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">ID CARGO</td>
                            <td class="has-text-left">{{ itemADetallar?.idCargo || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">CARGO</td>
                            <td class="has-text-left">{{ itemADetallar?.cargo || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">ABR TITULO</td>
                            <td class="has-text-left">{{ itemADetallar?.abrTitulo || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">CVE INSTITUCION</td>
                            <td class="has-text-left">{{ itemADetallar?.cveInstitucion || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">NOMBRE INSTITUCION</td>
                            <td class="has-text-left">{{ itemADetallar?.nombreInstitucion || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">CVE CARRERA</td>
                            <td class="has-text-left">{{ itemADetallar?.cveCarrera || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">NOMBRE CARRERA</td>
                            <td class="has-text-left">{{ itemADetallar?.nombreCarrera || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">FECHA INICIO CARRERA</td>
                            <td class="has-text-left">{{ itemADetallar?.fechaInicioCarrera || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">FECHA TERMINACION CARRERA</td>
                            <td class="has-text-left">{{ itemADetallar?.fechaTerminacionCarrera || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">ID AUTORIZACION RECONOCIMIENTO</td>
                            <td class="has-text-left">{{ itemADetallar?.idAutorizacionReconocimiento || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">AUTORIZACION RECONOCIMIENTO</td>
                            <td class="has-text-left">{{ itemADetallar?.autorizacionReconocimiento || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">NUMERO RVOE</td>
                            <td class="has-text-left">{{ itemADetallar?.numeroRvoe || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">CURP PROFESIONISTA</td>
                            <td class="has-text-left">{{ itemADetallar?.curpProfesionista || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">NOMBRE PROFESIONISTA</td>
                            <td class="has-text-left">{{ itemADetallar?.nombreProfesionista || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">PRIMER APELLIDO PROFESIONISTA</td>
                            <td class="has-text-left">{{ itemADetallar?.primerApellidoProfesionista || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">SEGUNDO APELLIDO PROFESIONISTA</td>
                            <td class="has-text-left">{{ itemADetallar?.segundoApellidoProfesionista || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">CORREO ELECTRONICO</td>
                            <td class="has-text-left">{{ itemADetallar?.correoElectronico || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">FECHA EXPEDICION</td>
                            <td class="has-text-left">{{ itemADetallar?.fechaExpedicion || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">ID MODALIDAD TITULACION</td>
                            <td class="has-text-left">{{ itemADetallar?.idModalidadTitulacion || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">MODALIDAD TITULACION</td>
                            <td class="has-text-left">{{ itemADetallar?.modalidadTitulacion || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">FECHA EXAMEN PROFESIONAL</td>
                            <td class="has-text-left">{{ itemADetallar?.fechaExamenProfesional || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">FECHA EXENCION EXAMEN PROFESIONAL</td>
                            <td class="has-text-left">{{ itemADetallar?.fechaExencionExamenProfesional || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">CUMPLIO SERVICIO SOCIAL</td>
                            <td class="has-text-left">{{ itemADetallar?.cumplioServicioSocial || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">ID FUNDAMENTO LEGAL SERVICIO SOCIAL</td>
                            <td class="has-text-left">{{ itemADetallar?.idFundamentoLegalServicioSocial || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">FUNDAMENTO LEGAL SERVICIO SOCIAL</td>
                            <td class="has-text-left">{{ itemADetallar?.fundamentoLegalServicioSocial || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">ID ENTIDAD FEDERATIVA EXPEDICION</td>
                            <td class="has-text-left">{{ itemADetallar?.idEntidadFederativaExpedicion || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">ENTIDAD FEDERATIVA EXPEDICION</td>
                            <td class="has-text-left">{{ itemADetallar?.entidadFederativaExpedicion || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">INSTITUCION PROCEDENCIA</td>
                            <td class="has-text-left">{{ itemADetallar?.institucionProcedencia || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">ID TIPO ESTUDIO ANTECEDENTE</td>
                            <td class="has-text-left">{{ itemADetallar?.idTipoEstudioAntecedente || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">TIPO ESTUDIO ANTECEDENTE</td>
                            <td class="has-text-left">{{ itemADetallar?.tipoEstudioAntecedente || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">ID ENTIDAD FEDERATIVA ANTECEDENTE</td>
                            <td class="has-text-left">{{ itemADetallar?.idEntidadFederativaAntecedente || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">ENTIDAD FEDERATIVA ANTECEDENTE</td>
                            <td class="has-text-left">{{ itemADetallar?.entidadFederativaAntecedente || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">FECHA INICIO ANTECEDENTE</td>
                            <td class="has-text-left">{{ itemADetallar?.fechaInicioAntecedente || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">FECHA TERMINACION ANTECEDENTE</td>
                            <td class="has-text-left">{{ itemADetallar?.fechaTerminacionAntecedente || 'N/A' }}</td>
                        </tr>
                        <tr>
                            <td class="has-text-left has-text-weight-bold">NO CEDULA</td>
                            <td class="has-text-left">{{ itemADetallar?.noCedula || 'N/A' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button is-pulled-right" (click)="cerrarModalDetalles()">Cerrar</button>
        </footer>
    </div>
</div>







<!-- Modal para Firmar Título -->
<div class="modal" [class.is-active]="showFirmarModal">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Firmar Título Electrónico</p>
            <button class="delete" aria-label="close" (click)="cerrarModalFirmar()"></button>
        </header>
        <section class="modal-card-body">
            <div class="card mb-4">
                <div class="card-content">
                    <div class="content">
                        <p><strong>Folio Control:</strong> {{ itemAFirmar?.folioControl }}</p>
                        <p><strong>Alumno:</strong> 
                            {{ itemAFirmar?.nombreProfesionista }} 
                            {{ itemAFirmar?.primerApellidoProfesionista }} 
                            {{ itemAFirmar?.segundoApellidoProfesionista }}
                        </p>
                        <p><strong>CURP:</strong> {{ itemAFirmar?.curpProfesionista }}</p>
                        <p><strong>Carrera:</strong> {{ itemAFirmar?.nombreCarrera }}</p>
                    </div>
                </div>
            </div>

            <div class="field">
                <label class="label">Contraseña de Firma</label>
                <div class="control">
                    <input 
                        class="input" 
                        type="password" 
                        [(ngModel)]="contrasenia_firma"
                        placeholder="Ingrese su contraseña de firma"
                        name="contrasenia_firma" value="**********">
                </div>
            </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button" (click)="cerrarModalFirmar()">Cerrar</button>
            <button class="button is-success" 
                    (click)="firmarTitulo()"
                    [disabled]="!contrasenia_firma.trim()">
                <span class="icon">
                    <i class="fas fa-signature"></i>
                </span>
                <span>Firmar Título</span>
            </button>
        </footer>
    </div>
</div>

<!-- Modal para Registrar Título -->
<div class="modal" [class.is-active]="showRegistrarModal">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Registrar Título Electrónico</p>
            <button class="delete" aria-label="close" (click)="cerrarModalRegistrar()"></button>
        </header>
        <section class="modal-card-body">
            <div class="card mb-4">
                <div class="card-content">
                    <div class="content">
                        <p><strong>Folio Control:</strong> {{ itemARegistrar?.folioControl }}</p>
                        <p><strong>Alumno:</strong> 
                            {{ itemARegistrar?.nombreProfesionista }} 
                            {{ itemARegistrar?.primerApellidoProfesionista }} 
                            {{ itemARegistrar?.segundoApellidoProfesionista }}
                        </p>
                        <p><strong>CURP:</strong> {{ itemARegistrar?.curpProfesionista }}</p>
                        <p><strong>Carrera:</strong> {{ itemARegistrar?.nombreCarrera }}</p>
                        <p><strong>Estado:</strong> {{ itemARegistrar?.sello ? 'FIRMADO' : 'NO FIRMADO' }}</p>
                    </div>
                </div>
            </div>

            <div *ngIf="errorRegistro" class="notification is-danger is-light">
                {{ errorRegistro }}
            </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button" (click)="cerrarModalRegistrar()">Cerrar</button>
            <button class="button is-primary" 
                    (click)="registrarTitulo()">
                <span class="icon">
                    <i class="fas fa-paper-plane"></i>
                </span>
                <span>Registrar Título</span>
            </button>
        </footer>
    </div>
</div>

<!-- Modal para Consultar Título -->
<div class="modal" [class.is-active]="showConsultarModal">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Consultar Título Electrónico</p>
            <button class="delete" aria-label="close" (click)="cerrarModalConsultar()"></button>
        </header>
        <section class="modal-card-body">
            <div class="card mb-4">
                <div class="card-content">
                    <div class="content">
                        <p><strong>Folio Control:</strong> {{ itemAConsultar?.folioControl }}</p>
                        <p><strong>CURP:</strong> {{ itemAConsultar?.curpProfesionista }}</p>
                        <p><strong>Alumno:</strong> 
                            {{ itemAConsultar?.nombreProfesionista }} 
                            {{ itemAConsultar?.primerApellidoProfesionista }} 
                            {{ itemAConsultar?.segundoApellidoProfesionista }}
                        </p>
                        <p><strong>Número Lote:</strong> {{ itemAConsultar?.numeroLote || 'N/A' }}</p>
                        <p><strong>Estatus Lote:</strong> 
                            <span [class]="getEstatusLoteClass(itemAConsultar?.estatusLote)">
                                {{ itemAConsultar?.estatusLote || 'N/D' }}
                            </span>
                        </p>
                        <p><strong>Mensaje:</strong> {{ itemAConsultar?.mensaje || 'N/A' }}</p>
                    </div>
                </div>
            </div>

            <div *ngIf="errorConsulta" class="notification is-danger is-light">
                {{ errorConsulta }}
            </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button" (click)="cerrarModalConsultar()">Cerrar</button>
            <button class="button is-info" 
                    (click)="consultarTitulo()">
                <span class="icon">
                    <i class="fas fa-refresh"></i>
                </span>
                <span>Consultar Título</span>
            </button>
        </footer>
    </div>
</div>




<!-- Modal para Cancelar Título Electrónico -->
<div class="modal" [class.is-active]="showCancelarModal">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <span class="icon has-text-danger mr-2">
                    <i class="fas fa-exclamation-triangle"></i>
                </span>
                Cancelar Título Electrónico
            </p>
            <button class="delete" aria-label="close" (click)="cerrarModalCancelar()"></button>
        </header>
        <section class="modal-card-body">
            <div class="card mb-4">
                <div class="card-content">
                    <div class="content">
                        <p><strong>Folio Control:</strong> {{ itemACancelar?.folioControl }}</p>
                        <p><strong>Alumno:</strong> 
                            {{ itemACancelar?.nombreProfesionista }} 
                            {{ itemACancelar?.primerApellidoProfesionista }} 
                            {{ itemACancelar?.segundoApellidoProfesionista }}
                        </p>
                        <p><strong>CURP:</strong> {{ itemACancelar?.curpProfesionista }}</p>
                        <p><strong>Carrera:</strong> {{ itemACancelar?.nombreCarrera }}</p>
                        <p><strong>Cancelado:</strong> 
                            <span *ngIf="itemACancelar?.cancelado === 1" class="tag is-danger">SI</span>
                            <span *ngIf="itemACancelar?.cancelado === 0 || !itemACancelar?.cancelado" class="tag is-light">NO</span>
                        </p>
                    </div>
                </div>
            </div>

            <div class="field">
                <label class="label">Motivo de Cancelación</label>
                <div class="control">
                    <div class="select is-fullwidth">
                        <select [(ngModel)]="id_motivo_cancelacion" name="id_motivo_cancelacion">
                            <option value="">Seleccione un motivo</option>
                            <option *ngFor="let motivo of motivosCancelacion" [value]="motivo.value">
                                {{ motivo.label }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="field">
                <label class="label">Escriba la frase CANCELAR TITULO</label>
                <div class="control">
                    <input 
                        class="input" 
                        type="text" 
                        [(ngModel)]="texto_confirm"
                        placeholder="CANCELAR TITULO"
                        name="texto_confirm">
                </div>
            </div>

            <div class="field">
                <label class="label">Contraseña de Firma</label>
                <div class="control">
                    <input 
                        class="input" 
                        type="password" 
                        [(ngModel)]="contrasenia_firma_cancelar"
                        placeholder="Ingrese su contraseña de firma"
                        name="contrasenia_firma_cancelar">
                </div>
            </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button" (click)="cerrarModalCancelar()">Cerrar</button>
            <button class="button is-danger" 
                    (click)="cancelarTitulo()"
                    [disabled]="!id_motivo_cancelacion || texto_confirm !== 'CANCELAR TITULO' || !contrasenia_firma_cancelar.trim() || itemACancelar?.cancelado === 1">
                <span class="icon">
                    <i class="fas fa-ban"></i>
                </span>
                <span>Cancelar Título</span>
            </button>
        </footer>
    </div>
</div>













<!-- Modal XML -->
<div class="modal" [class.is-active]="showXmlModal">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">XML del Trámite</p>
            <button class="delete" aria-label="close" (click)="cerrarModalXml()"></button>
        </header>
        <section class="modal-card-body">
            <div class="xml-viewer">  
                <pre><code (copy)="$event.preventDefault()">{{ xmlContent }}</code></pre>
            </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button" (click)="cerrarModalXml()">Cerrar</button>
            <button class="button is-primary" (click)="descargarXml()" [disabled]="!xmlContent">
                <span class="icon">
                    <i class="fas fa-download"></i>
                </span>
                <span>Descargar XML</span>
            </button>
        </footer>
    </div>
</div>

<div class="modal" [class.is-active]="showAutenticacionModal">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Autenticación</p>
            <button class="delete" aria-label="close" (click)="cerrarModalAutenticacion()"></button>
        </header>
        <section class="modal-card-body">
            <div class="card">
                <div class="card-content">
                    <div class="content">
                        <p><strong>Folio Control:</strong> {{ itemSeleccionado?.folioControl }}</p>
                        <p><strong>Alumno:</strong> 
                            {{ itemSeleccionado?.nombreProfesionista }} 
                            {{ itemSeleccionado?.primerApellidoProfesionista }} 
                            {{ itemSeleccionado?.segundoApellidoProfesionista }}
                        </p>
                        <p><strong>CURP:</strong> {{ itemSeleccionado?.curpProfesionista }}</p>
                        <p><strong>Carrera:</strong> {{ itemSeleccionado?.nombreCarrera }}</p>
                        <p><strong>Registro DGP:</strong> {{ itemSeleccionado?.lote || 'NO REGISTRADO' }}</p>
                        <p><strong>Status:</strong> {{ itemSeleccionado?.status_lote || 'N/A' }}</p>
                    </div>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button" (click)="cerrarModalAutenticacion()">Cerrar</button>
            <button class="button is-info" (click)="consultarStatus(itemSeleccionado)">
                <span class="icon">
                    <i class="fas fa-search"></i>
                </span>
                <span>Consultar Status</span>
            </button>
        </footer>
    </div>
</div>
